import RequestBuilder from '../Lib/Requests';

export default class SubscriptionService {
  api = new RequestBuilder();

  buildUserSubscriptionsToAssetMetricsRequest({ params, cancelToken }) {
    return {
      service: 'rules',
      endpoint: '/v1/metrics/subscriptions',
      method: 'get',
      params,
      cancelToken,
    };
  }

  async fetchUserSubscriptionsToAssetMetrics(params) {
    const { data = {} } = await this.api.request(
      this.buildUserSubscriptionsToAssetMetricsRequest(params)
    );
    return data;
  }

  buildUserSubscriptionsToAssetRequest({ params, cancelToken }) {
    return {
      service: 'rules',
      endpoint: '/v1/subscriptions',
      method: 'get',
      params,
      cancelToken,
    };
  }

  async fetchUserSubscriptionsToAsset(params) {
    const { data = {} } = await this.api.request(
      this.buildUserSubscriptionsToAssetRequest(params)
    );
    return data;
  }

  buildPostSubscriptionRequest({ params, data, cancelToken }) {
    const subId = data.Id ? `/${data.Id}` : '';
    return {
      service: 'rules',
      endpoint: `/v1/subscriptions${subId}`,
      method: 'post',
      params,
      data,
      cancelToken,
    };
  }
  async postSubscription(params) {
    const { data } = await this.api.request(
      this.buildPostSubscriptionRequest(params)
    );
    return data;
  }

  buildDeleteSubscriptionRequest({ subscriptionId, params, cancelToken }) {
    return {
      service: 'rules',
      endpoint: `/v1/subscriptions/${subscriptionId}`,
      method: 'delete',
      params,
      cancelToken,
    };
  }
  async deleteSubscription(params) {
    const { data } = await this.api.request(
      this.buildDeleteSubscriptionRequest(params)
    );
    return data;
  }

  buildSubscribeAllRequest({ params, data, cancelToken }) {
    return {
      service: 'rules',
      endpoint: '/v1/batch/subscribe-all',
      method: 'post',
      params,
      data,
      cancelToken,
    };
  }
  async subscribeAll(params) {
    const { data } = await this.api.request(
      this.buildSubscribeAllRequest(params)
    );
    return data;
  }

  buildUnsubscribeAllRequest({ params, data, cancelToken }) {
    return {
      service: 'rules',
      endpoint: '/v1/batch/unsubscribe-all',
      method: 'post',
      params,
      data,
      cancelToken,
    };
  }
  async unsubscribeAll(params) {
    const { data } = await this.api.request(
      this.buildUnsubscribeAllRequest(params)
    );
    return data;
  }
}
